/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：83
 */

"use strict"

var r
var o
var i
export { r as a }
export { o as b }
export { i as c };
(function (e) {
  e.TEXT = "TEXT"
  e.ICON = "ICON"
})(r || (r = {}));
(function (e) {
  e.OUTLINED_ICON = "OUTLINED_ICON"
  e.OUTLINED_TEXT = "OUTLINED_TEXT"
  e.CONTAINED_TEXT = "CONTAINED_TEXT"
  e.CONTAINED_ICON = "CONTAINED_ICON"
})(o || (o = {}));
(function (e) {
  e.TINY = "TINY"
  e.SMALL = "SMALL"
  e.MEDIUM = "MEDIUM"
  e.LARGE = "LARGE"
  e.HUGE = "HUGE"
})(i || (i = {}))
export default r
